export default __webpack_public_path__ + "static/media/6.14365250.jpg";